/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/assets/js/courses-faq-section.js ***!
  \**********************************************/
var myRadios = document.getElementsByName('pdp-question-item-new');
var setCheck;
var x = 0;

for (x = 0; x < myRadios.length; x++) {
  myRadios[x].onclick = function () {
    if (setCheck != this) {
      setCheck = this;
    } else {
      this.checked = false;
      setCheck = null;
    }
  };
}
/******/ })()
;